/* Aloha Palms - "?" info button next to the Dry Box option on product pages. */
(function () {
  var COPY =
    '<p><strong>Dry Box Add-On</strong></p>' +
    '<p>Get extra crackers plus more savory and sweet dry ingredients in a separate box. This creates more room on your main board for meats, cheeses, fruits, and premium selections while helping dry items stay crisp longer. A great-value way to add more variety and extend your servings.</p>' +
    '<p><strong>No Dry Box?</strong> Crackers and standard dry items such as nuts, pretzels, and some chocolates are placed on the board itself, and your order includes about one or two sleeves of crackers depending on board size.</p>';

  function isDryAddOn(text) {
    return /dry/i.test(text) && !/^\s*no\b/i.test(text);
  }

  function enhance() {
    document.querySelectorAll('.swatch-element').forEach(function (el) {
      if (el.getAttribute('data-ap-dry')) return;
      var label = el.querySelector('label');
      var text = (label ? label.textContent : el.textContent) || '';
      if (!isDryAddOn(text)) return;
      el.setAttribute('data-ap-dry', '1');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ap-dry-info__btn';
      btn.setAttribute('aria-label', 'What is the Dry Box Add-On?');
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = '?';

      var panel = document.createElement('div');
      panel.className = 'ap-dry-info__panel';
      panel.hidden = true;
      panel.innerHTML = COPY + '<button type="button" class="ap-dry-info__close">Got it</button>';

      el.classList.add('ap-dry-info__host');
      el.appendChild(btn);
      var wrap = el.parentNode;
      wrap.parentNode.insertBefore(panel, wrap.nextSibling);

      function toggle(e) {
        e.preventDefault(); e.stopPropagation();
        panel.hidden = !panel.hidden;
        btn.setAttribute('aria-expanded', String(!panel.hidden));
      }
      btn.addEventListener('click', toggle);
      panel.querySelector('.ap-dry-info__close').addEventListener('click', toggle);
    });
  }

  var style = document.createElement('style');
  style.textContent =
    '.ap-dry-info__host{position:relative;display:inline-flex !important;align-items:center;gap:6px}' +
    '.ap-dry-info__btn{width:22px;height:22px;min-width:22px;border-radius:50%;border:1px solid #2b5d73;background:#fff;' +
    'color:#2b5d73;font-weight:700;font-size:13px;line-height:20px;padding:0;cursor:pointer}' +
    '.ap-dry-info__panel{margin:10px 0 4px;padding:12px 14px;border:1px solid #2b5d73;border-radius:8px;background:#f2f8f9;' +
    'color:#1d3540;font-size:14px;line-height:1.45;text-align:left}' +
    '.ap-dry-info__panel p{margin:0 0 8px}' +
    '.ap-dry-info__close{border:0;background:none;color:#2b5d73;text-decoration:underline;padding:0;cursor:pointer;font:inherit}';
  document.head.appendChild(style);

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; enhance(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
})();
